const PLATFORM_URL =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://app.socialcurator.com'

const EXTERNAL = {
  app: PLATFORM_URL,
  account: `${PLATFORM_URL}/user/profile`,
  auth: `${PLATFORM_URL}/login?ref=academy`
}

const COURSE = {
  lesson: '/:courseSlug/:lessonSlug',
  preview: '/:courseSlug/preview',
  byLesson: (course: string, lesson: string) => `/${course}/${lesson}`,
  byPreview: (course: string) => `/${course}/preview`
}

export const ROUTES = {
  home: '/',
  community: '/community',
  confirmation: '/checkout/confirmation',
  checkout: '/checkout/:cid',
  connect: '/connect',
  external: EXTERNAL,
  course: COURSE
}
